import React from 'react';
import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Domains from './components/Domains';
import Main from './components/Main';
import Contact from './components/Contact';
import Header from './components/Header';
import Footer from './components/Footer';
import MainDomain from './components/MainDomain';

function App() {
  return (
    <div className="App">
      <Header/>
      <div className="main">
        <BrowserRouter>
          <Routes>
            <Route index element={<Main />} />
            <Route path="domains" element={<Domains />} />
            <Route path="domain/:type" element={<MainDomain />} />
            <Route path="contact" element={<Contact />} />
          </Routes>
        </BrowserRouter>
      </div>
      <Footer />
    </div>
  );
}

export default App;
